import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/root/elawphant/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["CellForm"] */ "/root/elawphant/src/widgets/cell-form/ui/CellForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/root/elawphant/src/widgets/footer/ui/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SmartHeader"] */ "/root/elawphant/src/widgets/smart-header/ui/SmartHeader.tsx");
